import { Box, Typography } from '@mui/material';
import { vipRoomIconsSprite } from '../../assets/bazzar';
import StoreCardShell, { StorePriceFooter, vipRoomHeaderGradient } from './StoreCardShell';

const vipRoomIconCrop = {
  family: { width: '384%', height: '250.98%', ml: '-23.25%', mt: '-75.25%' },
  party: { width: '384%', height: '250.98%', ml: '-143.19%', mt: '-75.25%' },
  corporate: { width: '384%', height: '250.98%', ml: '-268.3%', mt: '-75.25%' },
};

function VipRoomIcon({ iconType }) {
  const crop = vipRoomIconCrop[iconType] || vipRoomIconCrop.family;

  return (
    <Box
      sx={{
        width: { xs: 42, md: 42 },
        height: { xs: 43, md: 43 },
        overflow: 'hidden',
        flexShrink: 0,
      }}
    >
      <Box
        component="img"
        src={vipRoomIconsSprite}
        alt={`${iconType} room icon`}
        sx={{
          width: crop.width,
          height: crop.height,
          maxWidth: 'none',
          display: 'block',
          ml: crop.ml,
          mt: crop.mt,
        }}
      />
    </Box>
  );
}

export default function VipRoomCard({ card, onClick }) {
  return (
    <StoreCardShell
      headerGradient={vipRoomHeaderGradient}
      onClick={() => onClick(card)}
      footer={<StorePriceFooter price={card.price} originalPrice={card.originalPrice} />}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 1.4, md: 1.85 },
          height: { xs: '70%', md: '70%' },
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
        }}
      >
        <VipRoomIcon iconType={card.iconType} />
        <Box sx={{ mt: { xs: 0.75, md: 1.1 }, width: '100%', maxWidth: '100%', minWidth: 0, px: 0.5, textAlign: 'center' }}>
          <Typography
            sx={{
              color: '#fff',
              fontWeight: 700,
              fontSize: { xs: 32, md: 32 },
              lineHeight: '32px',
              letterSpacing: '0.8px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%',
            }}
          >
            {card.title}
          </Typography>
          <Typography
            sx={{
              color: '#fff',
              fontWeight: 400,
              fontSize: { xs: 10, md: 10 },
              lineHeight: '12px',
              letterSpacing: 0,
              width: '100%',
              mx: 'auto',
              textAlign: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            {card.subtitle}
          </Typography>
        </Box>
      </Box>
    </StoreCardShell>
  );
}
